import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhoneAlt, faTruck} from "@fortawesome/free-solid-svg-icons";

import Navbar from "../Common/Navbar";
import Loading from "../Common/Loading";

import { faStar as faSolidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";
class DriversList extends Component {
    state = {
        drivers : [],
        request: [],
        present_today : 0,
        present_tomorrow : 0,
        isLoaded: false,
    }
    onSearchDriver = (event) => {
        this.setState({driverName : event.target.value})
        if(event.target.value.length > 2) {
            const request = {
                expert_drivers : true,
                search_key : event.target.value
            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                expert_drivers : true,

            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }

    }
    onChangePresent = () => {
        const inputValue = 1 - this.state.present_today;
        this.setState({present_today : inputValue})
        if(inputValue) {
            this.setState({present_tomorrow : 0})
        }
        if(inputValue) {
            const request = {
                expert_drivers : true,
                present_today: 1
            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})
                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        else {
            const request = {
                expert_drivers : true,

            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})
                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    onChangePresentTomorrow = () => {
        const inputValue = 1 - this.state.present_tomorrow;
        this.setState({present_tomorrow : inputValue})
        if(inputValue) {
            this.setState({present_today : 0})
        }
        if(inputValue) {
            const request = {
                expert_drivers : true,
                present_tomorrow: 1
            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})
                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        else {
            const request = {
                expert_drivers : true,

            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers : response.results.drivers , request : response.results.request})
                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='لیست راننده ها'/>
                <section className="container p-4 rtl my-5">
                    <div className="row my-3">
                        <div className="col-7">
                            <div className="form-floating super-small-2">
                                <input type="text" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو  راننده"
                                       onChange={this.onSearchDriver}
                                       value={this.state.driverName}
                                />
                                <label htmlFor="floatingInput">جستجو راننده با نام خانوادگی</label>
                            </div>

                        </div>
                        <div className="custom-control custom-checkbox col-5 ">
                            <div className='custom-control custom-checkbox'>
                            <input type="checkbox"
                                   className="custom-control-input" id="is_personal_address"                                                        name="present_tomorrow"
                                   placeholder=""
                                   value = {1}
                                   checked={this.state.present_today}
                                   onChange={this.onChangePresent}
                            />
                            &nbsp;
                            <label htmlFor="is_personal_address"  className="custom-control-label super-small text-primary">  اعلام حضور  </label>
                            </div>
                         <div className='custom-control custom-checkbox mt-2'>
                             <input type="checkbox"
                                    className="custom-control-input" id="is_personal_address"                                                        name="present_tomorrow"
                                    placeholder=""
                                    value = {1}
                                    checked={this.state.present_tomorrow}
                                    onChange={this.onChangePresentTomorrow}
                             />
                             &nbsp;
                             <label htmlFor="is_personal_address"  className="custom-control-label super-small text-info"> اعلام حضور فردا </label>
                         </div>

                        </div>

                    </div>
                    {
                        this.state.drivers.map(driver => {

                            return (
                                <div className='row driver-row' key={driver.id}
                                     onClick={() => {this.props.history.push('/driver/' + driver.id) }}
                                >
                                    <div className="col-2">
                                        <img src={driver.avatar} alt="avatar" className='w-100 rounded-more'/>
                                        {
                                            driver.in_black_list > 0 &&
                                            <div className='alert alert-danger super-small-2 p-0 text-center mt-2' style={{fontSize: '8px'}}>
                                                لیست سیاه
                                            </div>
                                        }
                                        {
                                            driver.in_warning_list > 0 &&
                                            <div className='alert alert-warning super-small-2 p-0 text-center mt-2' style={{fontSize: '8px'}}>
                                                لیست تذکر
                                            </div>
                                        }
                                    </div>
                                    <div className="col-8">
                                        {driver.full_name}

                                        {driver.work_today ?
                                            <div className='badge badge-info badge-pill bg-warning super-small-2  mx-2'>
                                                اعلام حضور امروز
                                            </div> : ''
                                        }
                                        {driver.today_shift ?
                                            <div className='badge badge-info badge-pill bg-warning  mx-2'>
                                                شیفت کاری
                                            </div> : ''
                                        }
                                        {driver.rate > 0 && (
                                            <div title={driver.comment}>
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <FontAwesomeIcon
                                                        key={star}
                                                        icon={star <= driver.rate ? faSolidStar : faRegularStar}
                                                        style={{ color: "#ffc107", fontSize: 12, marginLeft: 2 }}
                                                    />
                                                ))}
                                                <span className="mx-2 super-small-2">({driver.rate})</span>
                                            </div>
                                        )}
                                        <div className='super-small-2 mt-2'>
                                            <FontAwesomeIcon icon={faTruck}/>
                                            &nbsp;
                                            {driver.car_type}
                                        </div>
                                        <div className='mt-2 fw-bold super-small'>
                                            {
                                                driver.cars[0] ? driver.cars[0].plaque : ''
                                            }
                                            {
                                                driver?.cars[0]?.dimensions &&
                                                <span className='badge rounded-pill bg-primary mx-3 px-2'>
                                                ابعاد:
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.width : ''
                                                    }
                                                   ,
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.height : ''
                                                    }
                                                    ,
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.length : ''
                                                    }

                                            </span>
                                            }

                                        </div>
                                    </div>
                                    <div className='col-2 pt-2'>
                                        <a href={'tel:' + driver.phone}>
                                            <FontAwesomeIcon icon={faPhoneAlt} className='text-success '/>
                                        </a>
                                    </div>

                                </div>

                            )

                        })
                    }
                </section>
                <Navbar/>
            </React.Fragment>
        );
    }

    componentDidMount() {
        const request = {
            expert_drivers: true,

        }
        API.getDrivers(request)
            .then((response) => {
                this.setState({drivers: response.results.drivers, request: response.results.request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default DriversList;